// Polyfills para compatibilidade e aceleração de página
import 'react-app-polyfill/stable'; // Polyfills estáveis para navegadores antigos
import 'react-app-polyfill/ie11'; // Suporte para IE11 (se necessário)

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import ThemeProvider from "./theme/ThemeProvider";
import './styles/animations.css'; // ✅ Animações modernas
import './styles/css-fixes.css'; // ✅ Correções de CSS obsoleto

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
